/*
 * CohortCourseware Messages
 *
 * This contains all the text for the CohortCourseware component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.courseware';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Courseware',
  },
  newCouseware: {
    id: `${scope}.newCourseware`,
    defaultMessage: 'New Courseware',
  },
  coursewareSettings: {
    id: `${scope}.coursewareSettings`,
    defaultMessage: 'Courseware Settings',
  },
});
